/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeleteSkillVersionRequest = {
  skillId: string;
  version: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const DeleteSkillVersionRequest$inboundSchema: z.ZodType<
  DeleteSkillVersionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skill_id: z.string(),
  version: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "skill_id": "skillId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type DeleteSkillVersionRequest$Outbound = {
  skill_id: string;
  version: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const DeleteSkillVersionRequest$outboundSchema: z.ZodType<
  DeleteSkillVersionRequest$Outbound,
  z.ZodTypeDef,
  DeleteSkillVersionRequest
> = z.object({
  skillId: z.string(),
  version: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    skillId: "skill_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function deleteSkillVersionRequestToJSON(
  deleteSkillVersionRequest: DeleteSkillVersionRequest,
): string {
  return JSON.stringify(
    DeleteSkillVersionRequest$outboundSchema.parse(deleteSkillVersionRequest),
  );
}
export function deleteSkillVersionRequestFromJSON(
  jsonString: string,
): SafeParseResult<DeleteSkillVersionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeleteSkillVersionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeleteSkillVersionRequest' from JSON`,
  );
}
